export const DASHBOARD_COMPRAS = () => '/dashboard-compras';

/**
 * transversal/at-90: o endereço que abre um pedido ou uma requisição direto no detalhe — é o que
 * o "Abrir pedido" do aviso de menção abre em outra aba. A página lê o parâmetro e o retira.
 */
export const DASHBOARD_COMPRAS_ITEM = (tipo: 'PEDIDO' | 'REQUISICAO', id: string) =>
  `/dashboard-compras?${tipo === 'PEDIDO' ? 'pedido' : 'requisicao'}=${encodeURIComponent(id)}`;
